import "./ScrollBar.scss";
import {useLocation, useNavigate} from "react-router";
import {useEffect, useMemo, useRef, useState} from "react";
import React from 'react';



const ScrollBar = (props: {children?: JSX.Element | JSX.Element[], getRef?: (e)=>void, id?: string}) => {
    const {children, getRef, id} = props;

    const scrollRef = useRef();

    useEffect(()=>{
    if(getRef) getRef(scrollRef);
    }, [scrollRef])

        return (
        <div id={id} className={"scrollbar-component" } ref={scrollRef}>
            {children && children || null}
        </div>
    );
};

export default ScrollBar;


